import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start at 14 minutes 39 seconds = 879 seconds
  const [timeLeft, setTimeLeft] = useState(879);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    // Format as HH:MM:SS if hours exist, otherwise MM:SS
    if (h > 0) {
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-[#27ae60] text-white py-3 px-4 text-center font-bold shadow-md" data-id="element-4">
      <div className="flex items-center justify-center gap-2 text-lg md:text-xl uppercase tracking-wide" data-id="element-5">
        <span data-id="element-6">Oferta termina en:</span>
        <span className="font-mono bg-black/20 px-2 py-0.5 rounded text-yellow-300" data-id="element-7">
          {formatTime(timeLeft)}
        </span>
      </div>
    </div>;
}